// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Moneyex_order__progress__fZBJ8 {
  padding: 2rem;
  background-color: var(--color-fash-green-1);
  border-radius: 0 2rem 2rem 0;
}
@media only screen and (max-width: 50em) {
  .Moneyex_order__progress__fZBJ8 {
    border-radius: 0 0 2rem 2rem;
  }
}
.Moneyex_order__progress__steps__j3f5Y {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  position: relative;
  padding: 2rem;
}
.Moneyex_order__progress__steps__line__DhNOO {
  content: "";
  position: absolute;
  border: 1px solid var(--color-dark);
  height: 93%;
  bottom: 1rem;
  left: 3.5rem;
}
.Moneyex_order__progress__steps__num__kJiBN {
  background-color: var(--color-dark);
  height: 3rem;
  width: 3rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--color-white);
}
.Moneyex_order__progress__steps__num__active__x5wj\\+ {
  background-color: var(--color-moneyex-primary-2);
  color: var(--color-dark);
}
.Moneyex_order__progress__steps__num__failed__TxDyG {
  background-color: var(--color-error);
}
.Moneyex_order__progress__step__XQ1wJ {
  display: flex;
  align-items: center;
  gap: 1rem;
  position: relative;
  z-index: 2;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Moneyex/Moneyex.module.scss"],"names":[],"mappings":"AAGI;EACI,aAAA;EACA,2CAAA;EACA,4BAAA;AAFR;AAIQ;EALJ;IAMQ,4BAAA;EADV;AACF;AAIQ;EACI,aAAA;EACA,sBAAA;EAGA,SAAA;EACA,kBAAA;EACA,aAAA;AAJZ;AAMY;EACI,WAAA;EACA,kBAAA;EACA,mCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAJhB;AAOY;EACI,mCAAA;EAEA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;AANhB;AASgB;EACI,gDAAA;EACA,wBAAA;AAPpB;AAWgB;EACI,oCAAA;AATpB;AAcQ;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;AAZZ","sourcesContent":["@import '../variables/breakpoints';\n\n.order {\n    &__progress {\n        padding: 2rem;\n        background-color: var(--color-fash-green-1);\n        border-radius: 0 2rem 2rem 0;\n\n        @media only screen and (max-width: $bp-800) {\n            border-radius: 0 0 2rem 2rem;\n        }\n\n\n        &__steps {\n            display: flex;\n            flex-direction: column;\n            // align-items: flex-end;\n            // justify-content: space-between;\n            gap: 2rem;\n            position: relative;\n            padding: 2rem;\n\n            &__line {\n                content: \"\";\n                position: absolute;\n                border: 1px solid var(--color-dark);\n                height: 93%;\n                bottom: 1rem;\n                left: 3.5rem;\n            }\n\n            &__num {\n                background-color: var(--color-dark);\n                ;\n                height: 3rem;\n                width: 3rem;\n                border-radius: 50%;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                color: var(--color-white);\n\n\n                &__active {\n                    background-color: var(--color-moneyex-primary-2);\n                    color: var(--color-dark);\n\n                }\n\n                &__failed {\n                    background-color: var(--color-error);\n                }\n            }\n        }\n\n        &__step {\n            display: flex;\n            align-items: center;\n            gap: 1rem;\n            position: relative;\n            z-index: 2;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"order__progress": `Moneyex_order__progress__fZBJ8`,
	"order__progress__steps": `Moneyex_order__progress__steps__j3f5Y`,
	"order__progress__steps__line": `Moneyex_order__progress__steps__line__DhNOO`,
	"order__progress__steps__num": `Moneyex_order__progress__steps__num__kJiBN`,
	"order__progress__steps__num__active": `Moneyex_order__progress__steps__num__active__x5wj+`,
	"order__progress__steps__num__failed": `Moneyex_order__progress__steps__num__failed__TxDyG`,
	"order__progress__step": `Moneyex_order__progress__step__XQ1wJ`
};
export default ___CSS_LOADER_EXPORT___;
